import React, { useState, useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import CloseIcon from './icons/CloseIcon';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
//   background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  pointer-events: none;
`;

const ModalContent = styled.div`
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
//   padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 90%;
  height: 90%;
  resize: both;
  overflow: auto;

    @media (max-width: 768px) {
        width: 100%;
        height: 100%;
        resize: none;
        border-radius: 0;
    }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: move;
  color: white;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: white;
`;

const IframeContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

function IframeModal({ isOpen, onClose, iframeSrc }) {
    const modalRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const dragStartPos = useRef({ x: 0, y: 0 });
    const [renderIframe, setRenderIframe] = useState(false);

    // useEffect(() => {
    //     if (isOpen && modalRef.current) {
    //         const modal = modalRef.current;
    //         const initialX = (window.innerWidth - modal.offsetWidth) / 2;
    //         const initialY = (window.innerHeight - modal.offsetHeight) / 2;
    //         setPosition({ x: initialX, y: initialY });
    //         setRenderIframe(true);
    //     }
    // }, [isOpen]);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        dragStartPos.current = { x: e.clientX - position.x, y: e.clientY - position.y };
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPosition({ x: e.clientX - dragStartPos.current.x, y: e.clientY - dragStartPos.current.y });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isOpen) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isOpen, isDragging]);

    return (
        <>
            <ModalOverlay style={{ display: isOpen ? 'flex' : 'none', pointerEvents: 'none' }}>
                                <div style={{pointerEvents: 'auto'}}>
                                    <ModalContent
                                        ref={modalRef}
                                        style={{
                                            transform: `translate(${position.x}px, ${position.y}px)`,
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <ModalHeader onMouseDown={handleMouseDown}>
                                            <span>AI</span>
                                            <CloseButton onClick={onClose}>
                                                <CloseIcon />
                                            </CloseButton>
                                        </ModalHeader>
                                        {/* {renderIframe && ( */}
                                            <IframeContainer>
                                                <StyledIframe
                                                    src={iframeSrc}
                                                    frameBorder="0"
                                                />
                                            </IframeContainer>
                                        {/* )} */}
                                    </ModalContent>
                                </div>
                            </ModalOverlay>
        
        </>
    );
}

export default IframeModal;